import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get, post} from "../../network/axiosServices";
// import {loaded} from "../global";


const initialState = {
    loading: false,
    posts: [],
    error: '',
}

export const fetchWhatWeDo = createAsyncThunk("fetchWhatWeDo", (params, {dispatch}) => {
    return get(params);
});

const postSlice = createSlice({
    name: 'whatwedo',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchWhatWeDo.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchWhatWeDo.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''

        })
        builder.addCase(fetchWhatWeDo.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
    }
})


export default postSlice.reducer
